import './base/';
import './utilities/is-touch';
import './utilities/responsive-images';
import './cart/cart';
import './cart/cart-utils';
import './cart/ajax-cart';
import './cart/ajax-cart-utils';
import './sliders/product-slider';
import './sliders/handle-slider';
import './sliders/history-slider';
import './product/ajax-actions';
import './product/quantity';
import './product/select-variants';
import './product/change-image';
import './product/related-products';
import './product/refresh-reviews-on-filtering';
import './product/handle-order-modal';
import './scroll/scroll-to-tab';
import './polyfills/object-fit';
import './tabs/handle-tabs';
import './tabs/handle-mobile-tabs-nav';
import './notion/handle-notion';
import './notion/close-notion';
import './search/handle-search-header';
import './video/handle-video-in-slider';
import './video/set-video-placeholder';
import './header/handle-sticky-header';
import './header/handle-product-bar';
import './menu/handle-mobile-menu';
import './menu/open-mobile-menu';
import './footer/handle-footer-mobile';
import './filters/handle-mobile-filters-trigger';
import './register/handle-interest';
import './modal/handle-modal';
import './pagination/scroll-to-top-on-change-page';
import './modules/accordions';
import './modules/current-link';

const $win = $(window);
const $doc = $(document);

// Your code goes here...
// jQuery.ready is no longer needed
